var bmHeaderColor = function () {
	var top_section_background = jQuery('section:first-of-type').css(
		'background-color'
	);
	jQuery('.bm-Option--Header__Background--Color-Match #bm-Header > div').css({
		background: top_section_background,
	});
};

jQuery(window).resize(function () {
	bmHeaderColor();
});

jQuery(document).ready(function () {
	bmHeaderColor();
});
